import tw, { styled } from "twin.macro";
import Button from "./Button";
import { ReactComponent as CloseIcon } from "app/assets/icons/close.svg";
import Text from "app/styles/Text";
import { BUSHA_URL, CANCELLED_STATUS } from "app/constants/variables";
import { ReactComponent as BushaLogo } from "app/assets/logo/busha-logo.svg";
import { useAppState } from "app/providers/AppStateProvider";

interface Props {
  onClose: () => void;
}
export default function CancelModal(props: Props) {
  const { displayMode, parentOrigin } = useAppState();

  const closeSession = () => {
    if (displayMode === "INLINE" && parentOrigin) {
      const target = window.parent;

      target.postMessage(
        {
          status: CANCELLED_STATUS,
        },
        parentOrigin
      );
    }
  };

  return (
    <Container>
      <div>
        <div tw="flex items-center justify-between mb-[16px]">
          <Text semiBold tw="text-[24px]">
            Cancel payment
          </Text>

          <button
            aria-label="Close cancel modal"
            type="button"
            tw="bg-containment-tertiary rounded-full h-[32px] w-[32px] flex items-center justify-center"
            onClick={props.onClose}
          >
            <CloseIcon tw="w-[16px] h-[16px]" />
          </button>
        </div>
        <Text medium subdued>
          Are you sure you want to cancel your payment? This action cannot be
          undone.
        </Text>
      </div>

      <div tw="flex flex-col gap-[16px]">
        <Button
          fullWidth
          size="xBig"
          variant="worry"
          text="Yes, cancel payment"
          onClick={closeSession}
        />

        <Button
          fullWidth
          size="xBig"
          variant="secondary"
          text="Dismiss"
          onClick={props.onClose}
        />
      </div>

      <Footer>
        <div tw="flex items-center gap-[8px]">
          <Text subdued>Secured by</Text>
          <a href={BUSHA_URL} target="_blank" rel="noopener noreferrer">
            <BushaLogo />
          </a>
        </div>
      </Footer>
    </Container>
  );
}

const Container = styled.div`
  ${tw`bg-containment-primary p-[20px] rounded-[20px] w-full max-w-[500px] flex flex-col gap-[24px]`};
`;

const Footer = styled.div`
  ${tw`flex gap-[16px] items-center justify-center text-[1.4rem]`};

  img {
    ${tw` h-[16px]`};
  }
`;
